import { fetcher } from "@website/fetcher/fetcher";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { useRouter } from "next/router";
import { GetBalanceMutationKey, GetBalanceResponseTypes } from "./types";

export const getBalanceApiURL = `${process.env.NEXT_PUBLIC_BASE_URL_PLATFORM}/wallet/v1/users/balance`;

export const useGetBalance = () => {
  const router = useRouter();
  const { isLoggedIn } = useLoginStatus();

  const { data, isLoading, isError, error, isSuccess, refetch } = useFetcher({
    queryKey: [GetBalanceMutationKey],
    queryFn: () =>
      fetcher({ url: getBalanceApiURL }, router).then(
        ({ data }) => data as GetBalanceResponseTypes
      ),
    retry: false,
    enabled: isLoggedIn
  });

  return {
    isLoadingGetBalance: isLoading,
    balance: data || { balance: 0, creditLimit: 0, ledgerBalance: 0 },
    isBalanceError: isError || error,
    isSuccess,
    refetch
  };
};
